module.exports = __webpack_public_path__ + "img/primo-fruits_382x550.cdbb7794.jpg";